import React, {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import MainLayout from "../../../../commons/layout/MainLayout";
import HeaderHs2 from "../../../../commons/components/Header/headerHs2";
import Button from "../../../../commons/components/Button";
import PhotoSelector from "../../../../commons/components/Forms/PhotoSelector";
import Slider from "../../../../commons/components/Slider";
import ROUTERS from "../../../../commons/constans/router";
import {Swiper, SwiperSlide} from "swiper/react";
import {Pagination} from "swiper";
import {sliceIntoChunks} from "../../../../utils/helpers";
import SwiperChildren from "../../../../commons/components/SwiperChildren/SwiperChildren";


const Character = ({
                       characterModels,
                       listFavoriteCharacter,
                       updateChildrenProfile
}) => {

    const [idCharacters,setIdCharacters] =  useState([]);

    useEffect(() => {
        if(listFavoriteCharacter.length > 0){
            let ids = [...idCharacters];
            listFavoriteCharacter.map(item => {
                ids.push(item.id);
            });

            setIdCharacters(ids)
        }
    },[listFavoriteCharacter])


    const navigate = useNavigate();

    const handleLeftClick = () => {
        navigate(ROUTERS.HOME);
    }


    const getIdCharacter = ids => {
        setIdCharacters(ids)
    }

    const onSlideChange = () => {
        window.scrollTo(0, 0)
    }


    return (
        <div className="information">
            <div className={'row p-0 m-0 text-center p-4'}>
                <div className={'col-12'}>
                    <p className={'p-0 m-0 information__title'}>우리 아이가 좋아하는 </p>
                    <p className={'p-0 m-0 information__title'}>캐릭터를 모두 선택해주세요! </p>
                </div>
            </div>
            <div className="information-slider" >
                <SwiperChildren
                    characterModels={characterModels || []}
                    getIdCharacter={getIdCharacter}
                    idCharacterActive={idCharacters}
                    onSlideChange={onSlideChange}
                />
            </div>
            <div className="row p-0 m-0 mb-3 mt-5">
                <div className={'col-12 '}>
                    <Button
                        customClass="btn-custom"
                        onClick={()=>{
                            updateChildrenProfile(idCharacters);
                        }}
                    >저장</Button>
                </div>

            </div>
        </div>
    )
}
Character.defaultProps = {
    listFavoriteCharacter: []
};

export default Character;